import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ToggleActivePayload = {
  id: EntityId
}

export const toggleCompartmentStatus = createAsyncThunk('compartments/toggleActive', async ({ id }: ToggleActivePayload) => {
  const results = await OLMSApiService.post<number>('/compartment/toggleActive', id)

  return results
})